import { render, staticRenderFns } from "./pindaan-h.vue?vue&type=template&id=f7b59b6c&"
import script from "./pindaan-h.vue?vue&type=script&lang=js&"
export * from "./pindaan-h.vue?vue&type=script&lang=js&"
import style0 from "./pindaan-h.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports